<template>
  <el-cascader
    ref="myCascader"
    v-model="value"
    :options="areaOption"
    @change="handleChange">
  </el-cascader>
</template>

<script>
import areaArr from '../../assets/js/area.js'
export default {
  name: 'AreaSelect',
  data () {
    return {
      value: '', // 选中的值
      areaOption: []
    }
  },
  created () {
    this.areaOption = areaArr
  },
  methods: {
    handleChange (value) {
      this.$emit('area', this.$refs.myCascader.getCheckedNodes()[0].pathLabels)
    }
  }
}
</script>

<style>
</style>
